if (!customElements.get("image-slider-gallery-component")) {
	class ImageSliderGallery extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.selectors = {
				sliderWrapper: ".image-slider-gallery__items",
				pagination: ".swiper-pagination",
				nextEl: ".swiper-btn-next",
				prevEl: ".swiper-btn-prev",
			};
			console.log(this.dataset);
			this.sectionId = this.dataset.sectionId;
			this.centerMode = this.dataset.centerMode === "true";
			this.columnsMobile = parseInt(this.dataset.columnsMobile) || 1;
			this.columnsDesktop = parseInt(this.dataset.columnsDesktop) || 4;
			this.columnsTablet =
				parseInt(this.dataset.columnsTablet) || columnsDesktop;
			this.autoplay = parseInt(this.dataset.autoplay) || 0;
			this.mobileGap = parseInt(this.dataset.mobileGap) || 20;

			this.sliderInstance = false;

			this.init();

			document.addEventListener("matchMobile", () => {
				this.init();
			});
			document.addEventListener("unmatchMobile", () => {
				this.init();
			});
			document.addEventListener("matchTablet", () => {
				this.init();
			});
			document.addEventListener("unmatchTablet", () => {
				this.init();
			});
		}

		init() {
			this.destroySlider();

			// Mobile and tablet always use mobile slider
			if (FoxTheme.config.mqlMobile || FoxTheme.config.mqlTablet) {
				this.initMobileSlider();
			} else {
				this.initDesktopSlider();
			}
		}

		initDesktopSlider() {
			if (typeof this.sliderInstance === "object") return;

			const sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
			const columnGap = FoxTheme.utils.getGridColumnGap(sliderWrapper);

			const sliderOptions = {
				slidesPerView: parseInt(this.columnsDesktop),
				spaceBetween: columnGap.desktop,
				navigation: false,
				pagination: false,
				breakpoints: {
					1280: {
						slidesPerView: parseInt(this.columnsDesktop),
						spaceBetween: columnGap.desktop,
					},
				},
				loop: false,
				threshold: 2,
			};

			const nextEl = this.querySelector(this.selectors.nextEl);
			const prevEl = this.querySelector(this.selectors.prevEl);
			const pagination = this.querySelector(this.selectors.pagination);

			if (nextEl && prevEl) {
				sliderOptions.navigation = {
					nextEl: nextEl,
					prevEl: prevEl,
				};
			}

			if (pagination) {
				sliderOptions.pagination = {
					el: pagination,
					type: "fraction",
				};
			}

			// Desktop slider doesn't use autoplay
			this.sliderInstance = new window.FoxTheme.Carousel(
				this,
				sliderOptions
			);
			this.sliderInstance.init();

			const focusableElements = FoxTheme.a11y.getFocusableElements(this);
			focusableElements.forEach((element) => {
				element.addEventListener("focusin", () => {
					const slide = element.closest(".swiper-slide");
					if (slide && this.sliderInstance && this.sliderInstance.slider) {
						this.sliderInstance.slider.slideTo(
							this.sliderInstance.slider.slides.indexOf(slide)
						);
					}
				});
			});

			if (Shopify.designMode && typeof this.sliderInstance === "object") {
				document.addEventListener("shopify:block:select", (e) => {
					if (e.detail.sectionId != this.sectionId) return;
					const index = Number(e.target.dataset.index);
					if (this.sliderInstance && this.sliderInstance.slider) {
						this.sliderInstance.slider.slideTo(index);
					}
				});
			}
		}

		initMobileSlider() {
			if (typeof this.sliderInstance === "object") return;

			const sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
			const columnGap = FoxTheme.utils.getGridColumnGap(sliderWrapper);

			const sliderOptions = {
				slidesPerView: this.centerMode ? (this.columnsMobile === 1 ? 1.2 : 2.2) : this.columnsMobile,
				centeredSlides: this.centerMode,
				spaceBetween: this.mobileGap,
				loop: this.centerMode,
				threshold: 5,
				grabCursor: true,
				slideToClickedSlide: this.centerMode,
				breakpoints: {
					480: {
						slidesPerView: this.centerMode ? (this.columnsMobile === 1 ? 1.3 : 2.3) : this.columnsMobile,
						spaceBetween: this.mobileGap,
					},
					768: {
						slidesPerView: this.centerMode ? (this.columnsMobile === 1 ? 2.5 : 3.5) : (this.columnsMobile * 2),
						spaceBetween: this.mobileGap,
					},
				},
			};

			const additionalModules = [];
			if (this.autoplay > 0) {
				sliderOptions.autoplay = {
					delay: this.autoplay,
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				};
				additionalModules.push(FoxTheme.Swiper.Autoplay);
			}

			this.sliderInstance = new window.FoxTheme.Carousel(
				this,
				sliderOptions,
				additionalModules.length > 0 ? additionalModules : null
			);
			this.sliderInstance.init();

			// Only apply opacity changes in center mode
			if (this.centerMode) {
				this.updateSlideOpacity();

				if (this.sliderInstance && this.sliderInstance.slider) {
					this.sliderInstance.slider.on("slideChange", () => {
						this.updateSlideOpacity();
					});

					this.sliderInstance.slider.on("transitionEnd", () => {
						this.updateSlideOpacity();
					});
				}
			}

			const focusableElements = FoxTheme.a11y.getFocusableElements(this);
			focusableElements.forEach((element) => {
				element.addEventListener("focusin", () => {
					const slide = element.closest(".swiper-slide");
					if (slide && this.sliderInstance && this.sliderInstance.slider) {
						this.sliderInstance.slider.slideTo(
							this.sliderInstance.slider.slides.indexOf(slide)
						);
					}
				});
			});

			if (Shopify.designMode && typeof this.sliderInstance === "object") {
				document.addEventListener("shopify:block:select", (e) => {
					if (e.detail.sectionId != this.sectionId) return;
					const index = Number(e.target.dataset.index);
					if (this.sliderInstance && this.sliderInstance.slider) {
						this.sliderInstance.slider.slideTo(index);
					}
				});
			}
		}

		updateSlideOpacity() {
			if (!this.sliderInstance || !this.sliderInstance.slider) return;

			const slides = this.querySelectorAll(".swiper-slide");
			const activeIndex = this.sliderInstance.slider.activeIndex;

			slides.forEach((slide, index) => {
				if (index === activeIndex) {
					slide.style.opacity = "1";
				} else {
					slide.style.opacity = "0.5";
				}
			});
		}

		destroySlider() {
			if (typeof this.sliderInstance !== "object") return;

			if (this.sliderInstance && this.sliderInstance.slider) {
				this.sliderInstance.slider.destroy();
				this.sliderInstance = false;
			}

			const slides = this.querySelectorAll(".swiper-slide");
			slides.forEach((slide) => {
				slide.style.opacity = "1";
			});
		}
	}
	customElements.define("image-slider-gallery-component", ImageSliderGallery);
}
